import App from '../App'
const Manage = () => import( /* webpackChunkName: "group-lt-manage" */ '../pages/Manage.vue');
const Home = () => import( /* webpackChunkName: "group-lt-home" */ '../pages/Home.vue');
const Col = () => import( /* webpackChunkName: "group-lt-article" */ '../pages/col.vue');
const Summary = () => import( /* webpackChunkName: "group-lt-article" */ '../pages/summary.vue');
const Plan = () => import( /* webpackChunkName: "group-lt-article" */ '../pages/plan.vue');
const Summary1 = () => import( /* webpackChunkName: "group-lt-article" */ '../pages/summary1.vue');
const Article = () => import( /* webpackChunkName: "group-lt-article" */ '../pages/article.vue');
const Allpage = () => import( /* webpackChunkName: "group-lt-article" */ '../pages/allpage.vue');




export default [{
  path: '/',
  component: App, //顶层路由，对应index.html
  children: [ //二级路由，对应App.vue  非同级路由监听会无效
    //地址为空时跳转home页面
    {
      path: '',
      redirect: '/home'
    },
    {
      path: '/manage',
      name: 'Manage',
      component: Manage,
      children: [{
          // 主页
          name: "Home",
          path: '/home',
          component: Home
        },
        {
          // 栏目
          name: 'Col',
          path: '/col',
          component: Col
        },
        {
          // 2020总结
          name: 'Summary',
          path: '/summary',
          component: Summary
        },
        {
          // 2020总结
          name: 'Plan',
          path: '/plan',
          component: Plan
        },
        {
          // 2020总结
          name: 'Summary1',
          path: '/summary1',
          component: Summary1
        },
        {
          // 文章内页
          name:'Article',
          path:'/Article',
          component:Article
        },
        {
          // 文章内页
          name:'Allpage',
          path:'/Allpage',
          component:Allpage
        }
      ]
    }
  ]
}]



// WEBPACK FOOTER //
// ./src/router/router.config.js